export const GrowthBookFeatureFlags = {
    OrderingPrepTime: 'ordering-prep-time',
    MobileMenuAtTopOfPage: 'mobile-menu-at-top-of-page',
    OopProductCardDesign: 'oop-product-card-design',
    DineInProductCardDesign: 'dine-in-product-card-design',
    OopCategoryTileMenu: 'oop-category-tile-menu',
    DineInCategoryTileMenu: 'dine-in-category-tile-menu',
    DeliveryMinOrder: 'delivery-min-order-value',
    OopMenuSearchVisibility: 'oop-menu-search-visibility',
} as const;
